import { useQuery } from "@tanstack/react-query";
import { ApiResponse, IUser } from "../../../core/_models";
import { getUsers } from "../../../project/core/_user";

// Define the actual API response structure
interface IUserListApiResponse extends ApiResponse {
    data: {
        list: IUser[]
    }
}

export const useUserMasterDataQuery = () => {
    const userData = useQuery<IUser[]>({  // Specify the return type as IUser[]
        queryKey: ["user-data"],
        queryFn: async () => {
            const response = await getUsers() as IUserListApiResponse;
            if (response.status !== "ok") {
                throw new Error(response.message);
            }
            return response.data.list;  // Returns IUser[]
        },
    });

    return {
        userData: userData.data ?? [],
        isLoading: userData.isLoading,
        isError: userData.isError,
        error: userData.error,
    };
};